import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import { ArrowBackIos } from "@material-ui/icons";
import Search from "@material-ui/icons/Search";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { Tooltip } from "recharts";

import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/report/agent";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class AgentReportOutbound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      agent: null,
    };
  }
  componentDidMount() {
    this.history = globalHistory();
    this.unlisten = this.history.listen(() => {
      this.itemInit();
    });
    this.itemInit();
  }

  listCollumns = [
    { id: "date", numeric: true, disablePadding: false, label: "Ngày" },
    {
      id: "answeredCalls",
      numeric: true,
      disablePadding: true,
      label: "Cuộc gọi nghe máy",
    },
    {
      id: "talkingTime",
      numeric: true,
      disablePadding: false,
      label: "Thời lượng nghe máy",
    },
    { id: "acd", numeric: true, disablePadding: false, label: "ACD" },
    { id: "view", numeric: true, disablePadding: false, label: "Chi tiết" },
  ];

  itemInit() {
    const id = this.props.match.params.id;
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getAgentReportDetail(id);
    this.props.getListReportAgentByDate(
      id,
      filters.where.gte,
      filters.where.lte
    );
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agentReportDetail != this.props.agentReportDetail) {
      const { agent } = this.props.agentReportDetail;
      this.setState({
        agent,
      });
    }
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleChange = (e, value) => {
    this.setState({ value });
  };

  handleView = (item) => {
    this.history.push(
      `${process.env.REACT_APP_PATH}/contact-center/report/agent-report-by-hour/${item.date}&${this.props.match.params.id}`
    );
  };

  render() {
    const { filters, agent, value } = this.state;
    const { classes, reportAgentByDate } = this.props;
    const reportAgentByDateResult =
      typeof reportAgentByDate === "object"
        ? Object.keys(reportAgentByDate).map((key) => reportAgentByDate[key])
        : reportAgentByDate;
    const dataReport = [["Ngày", "Nghe máy"]];
    for (const key in reportAgentByDateResult) {
      if (reportAgentByDateResult.hasOwnProperty(key)) {
        const value = reportAgentByDateResult[key];
        dataReport.push([value.date, value.answeredCalls]);
      }
    }
    return (
      <React.Fragment>
        <Paper square style={{ marginBottom: 15 }}>
          <Toolbar className={classes.toolbar}>
            <span className={classes.breadCrumb}>
              <Button
                size="small"
                disableRipple={true}
                onClick={() =>
                  this.history.push(
                    `${process.env.REACT_APP_PATH}/contact-center/report/agent-performance`
                  )
                }>
                <ArrowBackIos color="primary" />
                Báo cáo năng xuất điện thoại viên
              </Button>
            </span>
            <div style={{ flexGrow: 1 }}></div>
          </Toolbar>
          <div style={{ overflowX: "auto" }}>
            <ValidatorForm
              ref="form"
              onSubmit={this.handleSubmit}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <Card className={classes.card}>
                <CardContent>
                  <FormControl className={classes.form}>
                    <FormGroup className={classes.form}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid
                          container
                          spacing={24}
                          style={{ alignItems: "center" }}>
                          <Grid item md={3}>
                            <InlineDatePicker
                              margin="normal"
                              label="Thời gian bắt đầu"
                              variant="outlined"
                              className={classes.input}
                              value={filters.where.gte}
                              format="dd-MM-yyyy"
                              onChange={this.handleDateChangeStart}
                              name="gte"
                              keyboard
                              ampm={false}
                            />
                          </Grid>
                          <Grid item md={3}>
                            <InlineDatePicker
                              margin="normal"
                              label="Thời gian kết thúc"
                              variant="outlined"
                              className={classes.input}
                              value={filters.where.lte}
                              maxDate={new Date()}
                              minDate={filters.where.gte}
                              format="dd-MM-yyyy"
                              onChange={this.handleDateChangeEnd}
                              name="lte"
                              keyboard
                              ampm={false}
                            />
                          </Grid>
                          <Grid item md={3}>
                            <Tooltip title="Tìm kiếm" disableFocusListener>
                              <Fab
                                color="primary"
                                aria-label="Search"
                                className={classes.fab}
                                onClick={this.handleSubmit}>
                                <Search />
                              </Fab>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </FormGroup>
                  </FormControl>
                </CardContent>
              </Card>
            </ValidatorForm>
          </div>
        </Paper>
        <Paper
          square
          style={{
            marginBottom: 15,
            overflowX: "auto",
            justifyContent: "center",
            textAlign: "center",
          }}>
          <div
            style={{
              overflowX: "auto",
              justifyContent: "center",
              textAlign: "center",
            }}>
            <Typography component="h4" variant="h6" style={{ padding: 15 }}>
              Điện thoại viên: {agent ? agent.agentFullname : ""}
            </Typography>
            <Typography style={{ paddingBottom: 15, fontSize: 16 }}>
              {agent
                ? `Mã nhân viên: ${agent.agentCode}. Nhóm: ${agent.agentGroup}`
                : ""}
            </Typography>
          </div>
        </Paper>
        {reportAgentByDate.length != 0 ? (
          <Grid container spacing={24}>
            <Grid item md={12}>
              <Paper
                style={{
                  justifyContent: "center",
                  display: "flex",
                  backgroundColor: "#fff",
                  color: "#000",
                }}>
                <Chart
                  width={"100%"}
                  height={"600px"}
                  chartType="BarChart"
                  loader={<div>Loading Chart</div>}
                  data={dataReport}
                  options={{
                    title: "Báo cáo năng suất điện thoại viên theo ngày",
                    isStacked: true,
                    hAxis: {
                      title: "Số lượng cuộc gọi",
                      minValue: 0,
                    },
                    vAxis: {
                      title: "Ngày",
                    },
                  }}
                  // For tests
                  rootProps={{ "data-testid": "3" }}
                />
              </Paper>
            </Grid>
          </Grid>
        ) : null}
        <TableData
          {...this.props}
          nameTable="Danh sách báo cáo năng xuất điện thoại viên theo ngày"
          items={reportAgentByDateResult}
          rowsPerPage={filters.pageSize}
          count={reportAgentByDateResult.length}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={false}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleView={this.handleView}
        />
      </React.Fragment>
    );
  }
}

AgentReportOutbound.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  reportAgentByDate: state.reportAgent.reportAgentByDate,
  agentReportDetail: state.reportAgent.reportDetail,
});

AgentReportOutbound = connect(
  mapStateToProps,
  mapActionsToProps
)(AgentReportOutbound);
export default withStyles(styles)(AgentReportOutbound);
